module.exports = angular;


//////////////////
// WEBPACK FOOTER
// external "angular"
// module id = 25
// module chunks = 0 1